// Hook do tworzenia encji DevStudio

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPostEntityRequest {
  name: string;
  symbol: string;
  tableName: string;
  moduleUuid: string;
}

const postEntity = ({ name, symbol, tableName, moduleUuid }: IPostEntityRequest): Promise<void> =>
  axios.post('/panel/dev-studio/entities', {
    name,
    symbol,
    tableName,
    moduleUuid
  });

export const usePostEntity = (
  options?: UseMutationOptions<void, IError, IPostEntityRequest>
) => useMutation<void, IError, IPostEntityRequest>(postEntity, options);
